"use client"

import { useReportWebVitals } from "next/web-vitals"

export function WebVitals() {
  useReportWebVitals((metric) => {
    if (typeof window !== "undefined" && window.gtag) {
      window.gtag("event", metric.name, {
        value: Math.round(metric.name === "CLS" ? metric.value * 1000 : metric.value),
        event_category: metric.label === "web-vital" ? "Web Vitals" : "Next.js custom metric",
        event_label: metric.id,
        non_interaction: true,
      })
    }
  })

  return null
}
